/* eslint-disable */
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
// If you need to update this file, make changes in the Core application
// then run `import:api` in your terminal from the root of this project.
import { AxiosPromise } from 'axios';

import { baseClientConstructorProps } from 'app/api/apiClient/config';

import { BaseClient, BaseClientConstructorProps, QueryParams, SendRequestPayload } from '../baseClient';
import { 
  CoreAdminListCompaniesParams,
  UpdateSessionRequest,
  ListCompanyResponse,
  PayorIntegrationDto,
  LoginResponse,
  TypeDto
 } from '../types';

  //  CoreAdminClient
class CoreAdminClient extends BaseClient {
    constructor(props: BaseClientConstructorProps) {
        super(props);
    }

    readonly listCompanies = (queryParams: CoreAdminListCompaniesParams): AxiosPromise<ListCompanyResponse> => {
        let url_ = "/api/v1/core/admin/companies";

        const qParams = { ...queryParams };
        const hasExportReport = "exportReport" in qParams && qParams.exportReport;
        if (hasExportReport) {
            if ("page" in qParams) {
                delete qParams.page;
            }
            if ("pageSize" in qParams) {
                delete qParams.pageSize;
            }
        }

        const sendRequestPayload: SendRequestPayload = {
            responseType: hasExportReport ? "blob" : undefined,
            queryParams: qParams as unknown as QueryParams,
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly listPayorIntegrations = (id: string): AxiosPromise<PayorIntegrationDto> => {
        let url_ = "/api/v1/core/admin/payor_integrations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly updateSession = (payload: UpdateSessionRequest): AxiosPromise<LoginResponse> => {
        let url_ = "/api/v1/core/admin/session";

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "PUT",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly listTargetBankAccounts = (): AxiosPromise<TypeDto[]> => {
        let url_ = "/api/v1/core/admin/target_bank_accounts";

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }
}
// CoreAdminClient
  
export const coreAdminClient = new CoreAdminClient(baseClientConstructorProps);
